var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkPlaceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1445_50497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5547H8",
    stroke: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 10.3383V0.861328H6.22179V10.3383",
    stroke: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0.861328V10.3383",
    stroke: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 3.87695H6.22179",
    stroke: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77734 7.32227H6.22179",
    stroke: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1445_50497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 11.2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPlaceIcon);
export default __webpack_public_path__ + "static/media/WorkPlaceIcon.7043e455b78800502d7ec7f59bcc881c.svg";
export { ForwardRef as ReactComponent };